export default process.env;


// WEBPACK FOOTER //
// ./src/environmentVariables.js